import { useEffect, useState, useRef } from "react";
import { conversionAttempt, conversionFailure, conversionIntermediateFailure, conversionSuccess, formStart, pageView } from "../analytics";
import local from "../classes/local";

export const usePageView = (pageName) => {
    const lang = local.getItem('language'); // trigger new page view on language change
    useEffect(() => {
        pageView(pageName);
    }, [pageName, lang]);
};

export const usePageViewWithSteps = (pageName, stepNum, stepTitle) => {
    const lang = local.getItem('language'); // trigger new page view on language change
    useEffect(() => {
        pageView(pageName, stepNum, stepTitle);
    }, [pageName, stepNum, stepTitle, lang]);
};

/** used to mark "start" of a form (e.g. focusing into a form element) */
export const useFormStart = (flowName, pageNum = 1) => {
    const [started, setStarted] = useState(false);

    useEffect(() => {
        if (started) {
            formStart(flowName);
        }
    }, [started, flowName]);

    // If used on multiple pages in same component, allow pageNum change to reset started
    useEffect(() => {
        setStarted(false);
    }, [pageNum])

    return () => setStarted(true);

};

export const useConversion = (componentName, conversionName) => {

    const activeAttempt = useRef(false);

    const attempt = () => {
        conversionAttempt(componentName, conversionName);
        activeAttempt.current = true;
    }
   
    const success = () => {
        if (!activeAttempt.current) {
            return;
        }
        conversionSuccess(componentName, conversionName);
        activeAttempt.current = false;
    }
   
    const fail = (errorType, errorMessage, errorCode) => {
        conversionFailure(componentName, conversionName, errorType, errorMessage, errorCode);
        activeAttempt.current = false;
    };

    const failIntermediate = (errorType, errorMessage, errorCode) => {
        conversionIntermediateFailure(componentName, conversionName, errorType, errorMessage, errorCode);
    };

    /** Fail validation at final step */
    const failValidation = (errorMessage) => {
        if (!activeAttempt.current) {
            return;
        }
        fail('validation', errorMessage);
    }

    /** Final validation before final step (multi-step views only) */
    const failValidationIntermediate = (errorMessage) => {
        if (!activeAttempt.current) {
            return;
        }
        failIntermediate('validation', errorMessage);
    }

    /** Fail API call at final step */
    const failAPI = (errorMessage, errorCode = '') => {
        if (!activeAttempt.current) {
            return;
        }
        fail('system', errorMessage, errorCode);
    }

    /** Final API call before final step (multi-step views only) */
    const failAPIIntermediate = (errorMessage, errorCode = '') => {
        if (!activeAttempt.current) {
            return;
        }
        failIntermediate('system', errorMessage, errorCode);
    }

    return {
        attempt,
        success,
        failValidation,
        failValidationIntermediate,
        failAPI,
        failAPIIntermediate
    }
};